import { createSlice } from "@reduxjs/toolkit";
import type { RegisterInitRequest } from "@/services/api";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { SignUpState } from "./types";
import { SignUpStep, TOTAL_STEPS } from "./types";

const initialState: SignUpState = {
  currentStep: SignUpStep.UserDetails,
  userData: {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phoneNumber: "",
    username: "",
  },
  userDetailsErrorMessage: "",
  phoneNumberError: "",
  resendCoolDown: 0,
  smsErrorCount: 0,
  smsSentCount: 0,
  showCaptcha: false,
};

export const signUpSlice = createSlice({
  name: "signUp",
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStep < TOTAL_STEPS - 1) {
        state.currentStep += 1;
      }
    },
    prevStep: (state) => {
      if (state.currentStep > 0) {
        state.currentStep -= 1;
      }
    },
    resetSteps: (state) => {
      state.currentStep = SignUpStep.UserDetails;
    },
    goToStep: (state, action: PayloadAction<SignUpStep>) => {
      if (action.payload >= 0 && action.payload < TOTAL_STEPS) {
        state.currentStep = action.payload;
      }
    },
    setUserData: (state, action: PayloadAction<Partial<RegisterInitRequest>>) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    clearUserData: (state) => {
      state.userData = initialState.userData;
    },
    clearState: (state) => {
      Object.assign(state, initialState);
    },
    setUserDetailsError: (state, action: PayloadAction<string>) => {
      state.userDetailsErrorMessage = action.payload;
    },
    setPhoneNumberError: (state, action: PayloadAction<string>) => {
      state.phoneNumberError = action.payload;
    },
    setResendCoolDown: (state, action) => {
      state.resendCoolDown = action.payload;
    },
    incrementSmsErrorCount(state) {
      state.smsErrorCount += 1;
    },
    resetSmsErrorCount(state) {
      state.smsErrorCount = 0;
    },
    incrementSmsSentCount(state) {
      state.smsSentCount += 1;
    },
    resetSmsSentCount(state) {
      state.smsSentCount = 0;
    },
    showCaptcha(state) {
      state.showCaptcha = true;
    },
    hideCaptcha(state) {
      state.showCaptcha = false;
    },
  },
});

export const { actions: signUpActions, reducer: signUpReducer } = signUpSlice;
